import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3;

import { observable, runInAction, computed, makeObservable } from "mobx";
import * as yup from "yup";

var _SCHEMA = yup.object({
  isAgeConfirmed: yup.bool().oneOf([true], "")["default"](false)
});
/**
 * TODO:
 * 1. use yup default values in constructor (dynamic) using cast()
 */


var AgeConfirmModel = (_class = /*#__PURE__*/function () {
  function AgeConfirmModel(platformUtil) {
    _classCallCheck(this, AgeConfirmModel);

    _initializerDefineProperty(this, "_isAgeConfirmed", _descriptor, this);

    _initializerDefineProperty(this, "_isOrderContainAlcoholItem", _descriptor2, this);

    _initializerDefineProperty(this, "_componentRef", _descriptor3, this);

    _defineProperty(this, "platformUtil", void 0);

    this.platformUtil = platformUtil;
    this._isAgeConfirmed = false;
    this._isOrderContainAlcoholItem = false;
    makeObservable(this);
  }

  _createClass(AgeConfirmModel, [{
    key: "handleInvalidModel",
    value: function handleInvalidModel(appMessages) {
      var _this = this;

      var isMobile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      appMessages.showError("Missing Details.", "Please enter all highlighted fields.", null, {
        okBtnText: "OK",
        okBtnOnClick: function okBtnOnClick() {
          _this.platformUtil.scrollToElement(_this.componentRef, isMobile ? 30 : 0);
        }
      });
      this.platformUtil.dispatchEvent("AnalyticsEvent", "DisplayModal", {
        modalIntent: "Error modal for age confirmation",
        modalContent: "Error modal for age confirmation",
        modalName: "AgeConfirmation-Error-Modal"
      });
    }
  }, {
    key: "isValid",
    get: function get() {
      return this._isOrderContainAlcoholItem ? _SCHEMA.isValidSync(this) : true;
    }
  }, {
    key: "errors",
    get: function get() {
      var errObj = {};

      try {
        _SCHEMA.validateSync(this, {
          abortEarly: false
        });
      } catch (e) {
        var error = e;
        error.inner.forEach(function (err) {
          errObj[err.params.path] = err.message;
        });
      }

      return errObj;
    }
  }, {
    key: "isAgeConfirmed",
    get: function get() {
      return this._isAgeConfirmed;
    },
    set: function set(_isAgeConfirmed) {
      var _this2 = this;

      runInAction(function () {
        _this2._isAgeConfirmed = _isAgeConfirmed;
      });
    }
  }, {
    key: "isOrderContainAlcoholItem",
    get: function get() {
      return this._isOrderContainAlcoholItem;
    },
    set: function set(_isOrderContainAlcoholItem) {
      var _this3 = this;

      runInAction(function () {
        _this3._isOrderContainAlcoholItem = _isOrderContainAlcoholItem;
      });
    }
  }, {
    key: "componentRef",
    get: function get() {
      return this._componentRef;
    },
    set: function set(_componentRef) {
      var _this4 = this;

      runInAction(function () {
        _this4._componentRef = _componentRef;
      });
    }
  }]);

  return AgeConfirmModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_isAgeConfirmed", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_isOrderContainAlcoholItem", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_componentRef", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "isValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "errors", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "errors"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isAgeConfirmed", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isAgeConfirmed"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isOrderContainAlcoholItem", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isOrderContainAlcoholItem"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "componentRef", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "componentRef"), _class.prototype)), _class);
export { AgeConfirmModel as default };